import {Injectable, inject} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {ClientLogContext} from './client-log-context';
import {ClientLogDto} from './client-log-dto';
import {ClientLogLevel} from './client-log-level';
import {ClientLogTransport} from './client-log.transport';

@Injectable({providedIn: 'root'})
export class ClientLoggerService {
  private readonly transport = inject(ClientLogTransport);

  trace(message: string, context?: ClientLogContext): void { this.log('Trace', message, context); }
  debug(message: string, context?: ClientLogContext): void { this.log('Debug', message, context); }
  info(message: string, context?: ClientLogContext): void { this.log('Information', message, context); }
  warn(message: string, context?: ClientLogContext): void { this.log('Warning', message, context); }
  error(message: string, context?: ClientLogContext): void { this.log('Error', message, context); }
  critical(message: string, context?: ClientLogContext): void { this.log('Critical', message, context); }

  /** Current product policy: only Critical reaches either sink. Messages must contain no private data. */
  log(level: ClientLogLevel, message: string, context?: ClientLogContext): void {
    if (level !== 'Critical') return;
    const event: ClientLogDto = {
      level, message: message.slice(0, 1024),
      platform: Capacitor.getPlatform() === 'android' ? 'Android' : 'Web',
      httpStatus: context?.httpStatus, httpMethod: context?.httpMethod,
    };
    try { console.error('[Invemory Critical]', event); } catch { /* Console cannot disrupt the user flow. */ }
    try { this.transport.send(event); } catch { /* Logging must never become an application failure. */ }
  }
}
